export default {
	data: [],
	selectedDestine: [],
	errorModal: null,
	loadingState: false,
	clear: false,
	loadingData: true,
};
